import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ProfessionalCleaningHero from "./sections/ProfessionalCleaningHero";
import OurCoreCompetencies from "./sections/OurCoreCompetencies";
import UnserePakete from "./sections/UnserePakete";
import IhreVorteileMitUns from "./sections/IhreVorteileMitUns";
import ContactAppointmentSection from "./sections/ContactAppointmentSection";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ProfessionalCleaningHero />
      <OurCoreCompetencies />
      <UnserePakete />
      <IhreVorteileMitUns />
      <ContactAppointmentSection />
      <Footer />
    </div>;
}